export const FONT_STORAGE_KEY = "app.fontFamily";
export const FONT_CSS_VARIABLE = "--app-font-family";
export const DEFAULT_FONT_ID = "system";

export const FONT_OPTIONS = [
  {
    value: "system",
    label: "System Default",
    stack:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    category: "Sans Serif",
  },
  {
    value: "roboto",
    label: "Roboto",
    stack: '"Roboto", "Helvetica Neue", Arial, sans-serif',
    category: "Sans Serif",
  },
  {
    value: "inter",
    label: "Inter",
    stack: '"Inter", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    category: "Sans Serif",
  },
  {
    value: "arial",
    label: "Arial",
    stack: "Arial, Helvetica, sans-serif",
    category: "Sans Serif",
  },
  {
    value: "calibri",
    label: "Calibri",
    stack: 'Calibri, "Segoe UI", Candara, Optima, sans-serif',
    category: "Sans Serif",
  },
  {
    value: "verdana",
    label: "Verdana",
    stack: "Verdana, Geneva, sans-serif",
    category: "Sans Serif",
  },
  {
    value: "tahoma",
    label: "Tahoma",
    stack: "Tahoma, Geneva, sans-serif",
    category: "Sans Serif",
  },
  {
    value: "trebuchet",
    label: "Trebuchet MS",
    stack: '"Trebuchet MS", "Lucida Grande", sans-serif',
    category: "Sans Serif",
  },
  {
    value: "georgia",
    label: "Georgia",
    stack: 'Georgia, Cambria, "Times New Roman", serif',
    category: "Serif",
  },
  {
    value: "cambria",
    label: "Cambria",
    stack: 'Cambria, Georgia, "Times New Roman", serif',
    category: "Serif",
  },
  {
    value: "times",
    label: "Times New Roman",
    stack: '"Times New Roman", Times, serif',
    category: "Serif",
  },
  {
    value: "consolas",
    label: "Consolas",
    stack: 'Consolas, "SF Mono", Menlo, Monaco, "Courier New", monospace',
    category: "Monospace",
  },
  {
    value: "courier",
    label: "Courier New",
    stack: '"Courier New", Courier, monospace',
    category: "Monospace",
  },
];

export const isValidFont = (fontId) =>
  Boolean(fontId) && FONT_OPTIONS.some((option) => option.value === fontId);

export const getFontStack = (fontId) => {
  const match = FONT_OPTIONS.find((option) => option.value === fontId);
  return match ? match.stack : getDefaultFontStack();
};

export const getDefaultFontStack = () =>
  (FONT_OPTIONS.find((option) => option.value === DEFAULT_FONT_ID) ||
    FONT_OPTIONS[0]).stack;

export const applyFont = (fontId) => {
  if (typeof document === "undefined" || !document.documentElement) {
    return DEFAULT_FONT_ID;
  }
  const id = isValidFont(fontId) ? fontId : DEFAULT_FONT_ID;
  document.documentElement.style.setProperty(FONT_CSS_VARIABLE, getFontStack(id));
  try {
    localStorage.setItem(FONT_STORAGE_KEY, id);
  } catch (error) {
    // localStorage may be unavailable; fail silently
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent("fontChange", { detail: { font: id } })
    );
  }
  return id;
};

export const getStoredFont = () => {
  try {
    const value = localStorage.getItem(FONT_STORAGE_KEY);
    return isValidFont(value) ? value : DEFAULT_FONT_ID;
  } catch (error) {
    return DEFAULT_FONT_ID;
  }
};

export const initFont = () => {
  applyFont(getStoredFont());
};
